
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.7 31.5c-.2 0-.4-.1-.6-.2l-7-5.7H2c-1 0-1.8-.8-1.8-1.8V4.2c0-1 .8-1.8 1.8-1.8h30.2c.9.2 1.6 1 1.6 1.8v19.6c0 1-.8 1.8-1.8 1.8h-3.3v4.9c0 .4-.2.7-.6.9-.1.1-.3.1-.4.1zM2.2 23.6h18.2c.2 0 .5.1.6.2l5.7 4.6v-3.8c0-.6.4-1 1-1h4.1V4.4H2.2v19.2z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M8.4 11l1 1.9 2.1.3-1.5 1.6.4 2.1-2-1-1.9 1 .3-2.1-1.5-1.6 2.1-.3 1-1.9z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M17 11l1 1.9 2.1.3-1.5 1.6.3 2.1-1.9-1-1.9 1 .3-2.1-1.5-1.6 2.1-.3 1-1.9zm8.6 0l1 1.9 2.1.3-1.5 1.6.3 2.1-1.9-1-1.9 1 .3-2.1-1.5-1.6 2.1-.3 1-1.9z","fill":"#47AEA6"}})])
          )
        }
      }
    